export class Auth {

	ajaxAuth() {
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=6",
			type: 'POST',
			data: {
				action: 'login',
				login: $('#auth_block .auth-form__tel-select').val() + $('#auth_1_login').val(),
				password: $('#auth_1_pass').val(),
				auth_1_submit: 1,
				auth_1_remember: 1
			},
			dataType: "json",
			success: function (res) {
				$('#auth_submit').attr('disabled', false);

				if (res['success']) {
					location.replace('/cabinet/');
				}
				else {
					_this.showMistake('#auth_block', 'Ошибка: ' + res['error']);

					if (res['activate_link']) {
						$('#auth_block .form__mistakes').append('<p><a href="' + res['activate_link'] + '" target="_blank">Выслать код активации повторно</a></p>');
					}
				}
			},
			error: function (res) {
				$('#auth_popup input').attr('disabled', false);
				$('#auth_popup .error').text('Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	startTimer(type) {
		let time;

		if (type == 'email') {
			parent = '.popup-auth-code__container--email'
			time = 29;
		}
		else if (type == 'flashcall') {
			parent = '.popup-auth-code__container--flashcall'
			time = 29;
		}
		else if (type == 'sms') {
			parent = '.popup-auth-code__container--sms'
			time = 59;
		}

		$(parent + ' .code-form__repeat-caption').show();
		$(parent + ' .code-form__repeat-btn').prop('disabled', true);
		$(parent + ' .code-form__repeat').fadeIn();
		$(parent + ' .code-form__repeat-timer').text('00:' + (time < 10 ? '0' : '') + time);
		let intervalId = setInterval(function () {
			time--;
			$(parent + ' .code-form__repeat-timer').text('00:' + (time < 10 ? '0' : '') + time);
			if (time == 0) {
				clearInterval(intervalId);
				$(parent + ' .code-form__repeat-caption').hide();
				$(parent + ' .code-form__repeat-btn').prop('disabled', false);
			}
		}, 1000);
	}

	codePopup(type) {
		if (type == 'email') {
			$('.popup-auth-code').addClass('active');
			$('.popup-auth-code__container').removeClass('active');
			$('.popup-auth-code .popup-auth-code__container--email').addClass('active');
			$('body').addClass('no-scroll');
		}
		if (type == 'flashcall') {
			$('.popup-auth-code').addClass('active');
			$('.popup-auth-code__container').removeClass('active');
			$('.popup-auth-code .popup-auth-code__container--flashcall').addClass('active');
			$('body').addClass('no-scroll');
		}
		if (type == 'sms') {
			$('.popup-auth-code').addClass('active');
			$('.popup-auth-code__container').removeClass('active');
			$('.popup-auth-code .popup-auth-code__container--sms').addClass('active');
			$('body').addClass('no-scroll');
		}
	}

	async regPhone(type = 'auto') {
		$('.popup-auth-tel .auth-form__submit').prop('disabled', true);
		let _this = this;

		let recpatchaSelector = document.querySelector('meta[name="captcha"]');
		let recaptchaToken = "";
		if (recpatchaSelector) {
			let recpatchaKey = recpatchaSelector.content;
			recaptchaToken = await grecaptcha.execute(recpatchaKey, { action: 'submit' });
		}

		$.ajax({
			url: "/ajax.php?mid=22",
			type: 'POST',
			data: {
				action: 'reg_phone',
				str_phone: $('.popup-auth-tel #auth-tel').val(),
				type: type,
				token: recaptchaToken,
			},
			dataType: "json",
			success: function (res) {
				if (res.success) {
					$('.popup-auth-tel').removeClass('active');
					$('.popup-auth-tel .form__mistakes').text('');

					if (type == 'sms') {
						_this.codePopup('sms');
						$('.popup-auth-code .inputed_phone').text(res.phone);
						_this.startTimer('sms');
					}
					else if (res.email) {
						_this.codePopup('email');
						$('.popup-auth-code .inputed_phone').text(res.phone);
						$('.popup-auth-code .founded_email').text(res.email);
						_this.startTimer('email');
					}
					else {
						_this.codePopup('flashcall');
						$('.popup-auth-code .inputed_phone').text(res.phone);
						_this.startTimer('flashcall');
					}

					$('.popup-auth-tel .form__mistakes').text('');
					$('.popup-auth-tel .form__mistakes').hide();
				}
				else {
					$('.popup-auth-tel .form__mistakes').text(res.error);
					$('.popup-auth-tel .form__mistakes').show();
				}

				$('.popup-auth-tel .auth-form__submit').prop('disabled', false);
			},
			error: function (res) {
				$('.popup-auth-tel .auth-form__submit').prop('disabled', false);
				console.log(res);
			}
		});
	}

	submitCode(parent) {
		let form = $(parent);
		form.find('.auth-form__submit').prop('disabled', true);
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=22",
			type: 'POST',
			data: {
				action: 'check_code',
				code: form.find('.form__input--code').val()
			},
			dataType: "json",
			success: function (res) {
				if (res.success) {
					form.find('.form__mistakes').text('');
					location.reload();
				}
				else {
					form.find('.form__mistakes').show();
					form.find('.form__mistakes').text(res.error);
					form.find('.auth-form__submit').prop('disabled', false);
				}
			},
			error: function (res) {
				form.find('.auth-form__submit').prop('disabled', false);
				console.log(res);
			}
		});
	}

	regUser() {
		$('#reg_user_submit').prop('disabled', true);
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=7",
			type: 'POST',
			data: $('.auth__reg form').serialize() + '&action=reg_user',
			dataType: "json",
			success: function (res) {
				if (res.success) {
					_this.hideMistake('#reg_block');
					$('.auth__reg').hide();
					//$('#reg_step_3').fadeIn();
					if (res.get_bonus)
						location.replace('/cabinet/gifts/#show_gift_' + res.order_id);
					else
						location.replace('/');
				}
				else {
					_this.showMistake('.auth__reg', res.error);
				}
			},
			error: function (res) {
				$('#reg_user_submit').prop('disabled', false);
				console.log(res);
			}
		});
	}

	smsCodeInput(parent) {
		let code = $(parent).val();
		let digits = parseInt(code).toString().length;
		if (digits == 5) {
			$('#sms_code_submit').prop('disabled', false);
		}
		else {
			$('#sms_code_submit').prop('disabled', true);
		}
	}

	resetPass(parent) {
		let _this = this;
		let form = $(parent);
		let phone = form.find('input[name=str_phone]').val();
		form.find('input[type=submit]').prop('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=6",
			type: 'POST',
			data: { action: 'reset_pass', phone: phone },
			dataType: "json",
			success: function (res) {
				if (res.success) {
					_this.hideMistake(form);
					_this.hidePopup(form.closest('.popup'));
				}
				else {
					_this.showMistake(form, res.error);
				}
			},
			error: function (res) {
				form.find('input[type=submit]').prop('disabled', false);
				console.log(res);
			}
		});
	}

	showMistake(block, text) {
		$(block).find('.form__mistakes p').text(text);
		$(block).find('.form__mistakes').show();
	}

	hideMistake(block) {
		$(block).find('.form__mistakes p').text('');
		$(block).find('.form__mistakes').hide();
	}

	hidePopup(popup) {
		$("body").removeClass("no-scroll");
		popup.removeClass("active");
	}

	applyEvents() {
		let _this = this
		$('.header__login-form').submit(function () {
			_this.ajaxAuth();
			return false;
		});
	}

}

